import PicklistMetadata from "../PicklistMetadata";
import MemoryContext from "../../../util/MemoryContext";

class ProjectPlanPhaseMilestoneUSIDPicklistMetadata extends PicklistMetadata {
    constructor() {
        super();

        this.name = "ProjectPlanPhaseMilestoneUSID";
        this.bounded = true;
        this.enterpriseComponent = "ProjectPlanPhaseMilestoneLookup";
        this.longList = false;
        this.noDelete = true;
        this.noUpdate = true;
        this.noInsert = true;
        this.noMerge = true;
        this.useRealm = false;
        this.searchSpecification = {
            "ProjectPlanPhaseUSID": MemoryContext.components["ProjectPlanDetail-EO-PhaseUSID"]
        };
        this.sortSpecification = null;
        this.static = false;
        this.typeField = "Name";
        this.typeValue = "USID";
        this.typeValue2 = null;
        this.visibilityType = null;
    }
}

export default ProjectPlanPhaseMilestoneUSIDPicklistMetadata;
